module.exports = __webpack_public_path__ + "img/s3-3.c8b4176b.jpg";